import React from 'react';

export type BooleanStatusProps = {
  value: boolean;
  trueText?: string;
  falseText?: string;
  className?: string;
  style?: React.CSSProperties;
};

export const BooleanStatus: React.FC<BooleanStatusProps> = ({
  value,
  trueText = 'Yes',
  falseText = 'No',
  className = '',
  style = {},
}) => {
  return value ? (
    <span className={`text-success ${className}`} style={style}>
      {trueText}
    </span>
  ) : (
    <span className={`text-danger ${className}`} style={style}>
      {falseText}
    </span>
  );
};
